module.exports = __webpack_public_path__ + "img/discount19.1c9b67fb.png";